<template>
    <div>
        <div class="modal" id="erpSyncSettingModal" data-backdrop="static" data-keyboard="false" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                <div class="modal-content">
                    <div class="modal-header p-2 px-3">
                        <h5 class="modal-title text-black font-medium text-base">Sync Settings  <span v-if="vistaConnection"  class="text-dark font-bold">({{vistaConnection.name}})</span></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white min-h-screen-60 p-0">
                        <div v-if="loader" class="loader-overlay">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div>
                            <ul class="nav nav-pills bg-grey-lighter mb-3" id="pills-tab" role="tablist">
                                <!-- Project -->
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link bg-transparent text-black rounded-0 active" id="pills-project-tab" data-toggle="pill" data-target="#pills-project" type="button" role="tab" aria-controls="pills-project" aria-selected="true">
                                        Project
                                    </button>
                                </li>

                                <!-- Company -->
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link bg-transparent text-black rounded-0" id="pills-company-tab" data-toggle="pill" data-target="#pills-company" type="button" role="tab" aria-controls="pills-company" aria-selected="false">
                                        Company
                                    </button>
                                </li>

                                <!-- Residential Contact -->
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link bg-transparent text-black rounded-0" id="pills-residential-contact-tab" data-toggle="pill" data-target="#pills-residential-contact" type="button" role="tab" aria-controls="pills-residential-contact" aria-selected="false">
                                        Residential Contact
                                    </button>
                                </li>

                                <!-- Change Order -->
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link bg-transparent text-black rounded-0" id="pills-change-order-tab" data-toggle="pill" data-target="#pills-change-order" type="button" role="tab" aria-controls="pills-change-order" aria-selected="false">
                                        Change Order
                                    </button>
                                </li>

                                <!-- Work Order -->
                                <li v-if="connectedErpIntegration === 'vista'" class="nav-item" role="presentation">
                                    <button class="nav-link bg-transparent text-black rounded-0" id="pills-work-order-tab" data-toggle="pill" data-target="#pills-work-order" type="button" role="tab" aria-controls="pills-work-order" aria-selected="false">
                                        Work Order
                                    </button>
                                </li>

                                <!-- JC Contracts -->
                                <li v-if="connectedErpIntegration === 'vista'" class="nav-item" role="presentation">
                                    <button class="nav-link bg-transparent text-black rounded-0" id="pills-jc-contract-tab" data-toggle="pill" data-target="#pills-jc-contract" type="button" role="tab" aria-controls="pills-jc-contract" aria-selected="false">
                                        JC Contracts
                                    </button>
                                </li>
                            </ul>

                            <div class="tab-content px-3" id="pills-tabContent">
                                <!-- Project Tab -->
                                <div class="tab-pane text-black text-sm fade show active" id="pills-project" role="tabpanel" aria-labelledby="pills-project-tab">
                                    <!-- Project Push -->
                                    <div>
                                        How would you like your project to push?
                                        <i
                                            class="fa fa-info-circle text-grey-dark"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="Settings are available based on the mapping directions within individual modules.">
                                        </i>
                                    </div>
                                    <b-form-group v-slot="{ ariaDescribedby }">
                                        <b-form-radio v-for="syncType in syncSettingTypes" :key="'project-push-'+syncType.id"
                                                      v-model="syncSetting.project.push.type"
                                                      :aria-describedby="ariaDescribedby"
                                                      :name="'project-push-'+syncType.id"
                                                      :value="syncType.id"
                                                      :disabled="syncType.id === 'automatic' && (!isProjectModuleExistsOrEnabled || !isProjectPushAllowed)"
                                                      stacked>
                                            {{ syncType.label }}
                                        </b-form-radio>
                                    </b-form-group>

                                    <!-- Project Push Depend On -->
                                    <div v-if="syncSetting.project.push.type === 'automatic'" class="bg-grey-lighter depend-on-section border-1 ml-5 p-2">
                                        <!-- Depend On Type -->
                                        <b-form-group label="Depending On..." v-slot="{ ariaDescribedby }" :disabled="!isProjectPushAllowed">
                                            <b-form-radio v-for="dependType in projectPushDependTypes" :key="'project-push-depend-'+dependType.id"
                                                          v-model="syncSetting.project.push.depends"
                                                          :aria-describedby="ariaDescribedby"
                                                          :name="'project-push-depend-'+dependType.id"
                                                          :value="dependType.id"
                                                          stacked>
                                                <div class="radio-label">
                                                    <p class="radio-title">{{ dependType.label }}</p>
                                                    <small class="radio-description">Push projects when a project reaches a set status</small>

                                                    <!-- Sales Status -->
                                                    <div v-if="syncSetting.project.push.depends === 'sales-status' && dependType.id === 'sales-status'">
                                                        <div class="my-2">
                                                            <label>Status</label>
                                                            <b-form-select
                                                                v-model="syncSetting.project.push.salesStatusId"
                                                                :options="salesStatuses"
                                                                value-field="id"
                                                                text-field="code"
                                                            ></b-form-select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-form-radio>
                                        </b-form-group>
                                    </div>

                                    <!-- Project Sync -->
                                    <div class="mt-3 mb-1">
                                        How would you like your project to sync?
                                        <i
                                            class="fa fa-info-circle text-grey-dark"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="Settings are available based on the mapping directions within individual modules.">
                                        </i>
                                    </div>
                                    <b-form-group v-slot="{ ariaDescribedby }">
                                        <b-form-radio v-for="syncType in syncSettingTypes" :key="'project-sync-'+syncType.id"
                                                      v-model="syncSetting.project.sync.type"
                                                      :aria-describedby="ariaDescribedby"
                                                      :name="'project-sync-'+syncType.id"
                                                      :value="syncType.id"
                                                      :disabled="syncType.id === 'automatic' && !isProjectModuleExistsOrEnabled"
                                                      stacked>
                                            {{ syncType.label }}
                                        </b-form-radio>
                                    </b-form-group>

                                    <!-- Project Sync Depend On -->
                                    <erp-sync-setting-automatic-sync v-if="syncSetting.project.sync.type === 'automatic'"
                                                                     key="project-sync"
                                                                     type="project"
                                                                     type-label="project"
                                                                     :sync-depend-types="syncDependTypes"
                                                                     :time-interval-types="timeIntervalTypes"
                                                                     :time-interval-unit-types="timeIntervalUnitTypes"
                                                                     :time-interval-direction-types="timeIntervalDirectionTypes"
                                                                     :sync-settings="syncSetting.project.sync"
                                                                     :is-project-push-allowed="isProjectPushAllowed"
                                                                     :is-project-sync-allowed="isProjectSyncAllowed"
                                                                     :connected-erp-integration="connectedErpIntegration"
                                                                     :connected-e-r-p-name="connectedERPName"
                                                                     v-on:syncSettingChanged="getChangedSyncSetting">
                                    </erp-sync-setting-automatic-sync>
                                </div>

                                <!-- Company Tab -->
                                <div class="tab-pane text-black text-sm fade" id="pills-company" role="tabpanel" aria-labelledby="pills-company-tab">
                                    <!-- Company Sync -->
                                    <div>
                                        How would you like your company to sync?
                                        <i
                                            class="fa fa-info-circle text-grey-dark"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="Settings are available based on the mapping directions within individual modules.">
                                        </i>
                                    </div>
                                    <b-form-group v-slot="{ ariaDescribedby }">
                                        <b-form-radio v-for="syncType in syncSettingTypes" :key="'company-sync-'+syncType.id"
                                                      v-model="syncSetting.company.sync.type"
                                                      :aria-describedby="ariaDescribedby"
                                                      :name="'company-sync-'+syncType.id"
                                                      :value="syncType.id"
                                                      :disabled="syncType.id === 'automatic' && !isCompanyModuleExistsOrEnabled"
                                                      stacked>
                                            {{ syncType.label }}
                                        </b-form-radio>
                                    </b-form-group>

                                    <!-- Company Sync Depend On -->
                                    <erp-sync-setting-automatic-sync v-if="syncSetting.company.sync.type === 'automatic'"
                                                                     key="company-sync"
                                                                     type="company"
                                                                     type-label="company"
                                                                     :sync-depend-types="syncDependTypes"
                                                                     :time-interval-types="timeIntervalTypes"
                                                                     :time-interval-unit-types="timeIntervalUnitTypes"
                                                                     :time-interval-direction-types="timeIntervalDirectionTypes"
                                                                     :sync-settings="syncSetting.company.sync"
                                                                     :is-company-push-allowed="isCompanyPushAllowed"
                                                                     :is-company-sync-allowed="isCompanySyncAllowed"
                                                                     :connected-erp-integration="connectedErpIntegration"
                                                                     :connected-e-r-p-name="connectedERPName"
                                                                     v-on:syncSettingChanged="getChangedSyncSetting">
                                    </erp-sync-setting-automatic-sync>
                                </div>

                                <!-- Residential Contact Tab -->
                                <div class="tab-pane text-black text-sm fade" id="pills-residential-contact" role="tabpanel" aria-labelledby="pills-residential-contact-tab">
                                    <!-- Residential Contact Sync -->
                                    <div>
                                        How would you like your residential contact to sync?
                                        <i
                                            class="fa fa-info-circle text-grey-dark"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="Settings are available based on the mapping directions within individual modules.">
                                        </i>
                                    </div>
                                    <b-form-group v-slot="{ ariaDescribedby }">
                                        <b-form-radio v-for="syncType in syncSettingTypes" :key="'residential-contact-sync-'+syncType.id"
                                                      v-model="syncSetting.residentialContact.sync.type"
                                                      :aria-describedby="ariaDescribedby"
                                                      :name="'residential-contact-sync-'+syncType.id"
                                                      :value="syncType.id"
                                                      :disabled="syncType.id === 'automatic' && !isResidentialContactModuleExistsOrEnabled"
                                                      stacked>
                                            {{ syncType.label }}
                                        </b-form-radio>
                                    </b-form-group>

                                    <!-- Residential Contact Sync Depend On -->
                                    <erp-sync-setting-automatic-sync v-if="syncSetting.residentialContact.sync.type === 'automatic'"
                                                                     key="residential-contact-sync"
                                                                     type="residentialContact"
                                                                     type-label="residential contact"
                                                                     :sync-depend-types="syncDependTypes"
                                                                     :time-interval-types="timeIntervalTypes"
                                                                     :time-interval-unit-types="timeIntervalUnitTypes"
                                                                     :time-interval-direction-types="timeIntervalDirectionTypes"
                                                                     :sync-settings="syncSetting.residentialContact.sync"
                                                                     :is-residential-contact-push-allowed="isResidentialContactPushAllowed"
                                                                     :is-residential-contact-sync-allowed="isResidentialContactSyncAllowed"
                                                                     :connected-erp-integration="connectedErpIntegration"
                                                                     :connected-e-r-p-name="connectedERPName"
                                                                     v-on:syncSettingChanged="getChangedSyncSetting">
                                    </erp-sync-setting-automatic-sync>
                                </div>

                                <!-- Change Order Tab -->
                                <div class="tab-pane text-black text-sm fade" id="pills-change-order" role="tabpanel" aria-labelledby="pills-change-order-tab">
                                    <!-- Change Order Sync -->
                                    <div>
                                        How would you like your change order to sync?
                                        <i
                                            class="fa fa-info-circle text-grey-dark"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="Settings are available based on the mapping directions within individual modules.">
                                        </i>
                                    </div>
                                    <b-form-group v-slot="{ ariaDescribedby }">
                                        <b-form-radio v-for="syncType in syncSettingTypes" :key="'change-order-sync-'+syncType.id"
                                                      v-model="syncSetting.changeOrder.sync.type"
                                                      :aria-describedby="ariaDescribedby"
                                                      :name="'change-order-sync-'+syncType.id"
                                                      :value="syncType.id"
                                                      :disabled="syncType.id === 'automatic' && !isChangeOrderModuleExistsOrEnabled"
                                                      stacked>
                                            {{ syncType.label }}
                                        </b-form-radio>
                                    </b-form-group>

                                    <!-- Change Order Sync Depend On -->
                                    <erp-sync-setting-automatic-sync v-if="syncSetting.changeOrder.sync.type === 'automatic'"
                                                                     key="change-order-sync"
                                                                     type="changeOrder"
                                                                     type-label="change order"
                                                                     :sync-depend-types="syncDependTypes"
                                                                     :time-interval-types="timeIntervalTypes"
                                                                     :time-interval-unit-types="timeIntervalUnitTypes"
                                                                     :time-interval-direction-types="timeIntervalDirectionTypes"
                                                                     :sync-settings="syncSetting.changeOrder.sync"
                                                                     :is-change-order-push-allowed="isChangeOrderPushAllowed"
                                                                     :is-change-order-sync-allowed="isChangeOrderSyncAllowed"
                                                                     :connected-erp-integration="connectedErpIntegration"
                                                                     :connected-e-r-p-name="connectedERPName"
                                                                     v-on:syncSettingChanged="getChangedSyncSetting">
                                    </erp-sync-setting-automatic-sync>
                                </div>

                                <!-- Work Order Tab -->
                                <div v-if="connectedErpIntegration === 'vista'" class="tab-pane text-black text-sm fade" id="pills-work-order" role="tabpanel" aria-labelledby="pills-work-order-tab">
                                    <!-- Work Order Push -->
                                    <div>
                                        How would you like your work order to push?
                                        <i
                                            class="fa fa-info-circle text-grey-dark"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="Settings are available based on the mapping directions within individual modules.">
                                        </i>
                                    </div>
                                    <b-form-group v-slot="{ ariaDescribedby }">
                                        <b-form-radio v-for="syncType in syncSettingTypes" :key="'work-order-'+syncType.id"
                                                      v-model="syncSetting.workOrder.push.type"
                                                      :aria-describedby="ariaDescribedby"
                                                      :name="'work-order-push-'+syncType.id"
                                                      :value="syncType.id"
                                                      :disabled="syncType.id === 'automatic' && (!isWorkOrderModuleExistsOrEnabled || !isWorkOrderPushAllowed)"
                                                      stacked>
                                            {{ syncType.label }}
                                        </b-form-radio>
                                    </b-form-group>

                                    <!-- Work Order Push Depend On -->
                                    <div v-if="syncSetting.workOrder.push.type === 'automatic'" class="bg-grey-lighter depend-on-section border-1 ml-5 p-2">
                                        <!-- Depend On Type -->
                                        <b-form-group label="Depending On..." v-slot="{ ariaDescribedby }">
                                            <b-form-radio v-for="dependType in projectPushDependTypes" :key="'work-order-push-depend-'+dependType.id"
                                                          v-model="syncSetting.workOrder.push.depends"
                                                          :aria-describedby="ariaDescribedby"
                                                          :name="'work-order-push-depend-'+dependType.id"
                                                          :value="dependType.id"
                                                          stacked>
                                                <div class="radio-label">
                                                    <p class="radio-title">{{ dependType.label }}</p>
                                                    <small class="radio-description">Push work order when a project reaches a set status</small>

                                                    <!-- Sales Status -->
                                                    <div v-if="syncSetting.workOrder.push.depends === 'sales-status' && dependType.id === 'sales-status'">
                                                        <div class="my-2">
                                                            <label>Status</label>
                                                            <b-form-select
                                                                v-model="syncSetting.workOrder.push.salesStatusId"
                                                                :options="salesStatuses"
                                                                value-field="id"
                                                                text-field="code"
                                                            ></b-form-select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-form-radio>
                                        </b-form-group>
                                    </div>

                                    <!-- Work Order Sync -->
                                    <div>
                                        How would you like your work order to sync?
                                        <i
                                            class="fa fa-info-circle text-grey-dark"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="Settings are available based on the mapping directions within individual modules.">
                                        </i>
                                    </div>
                                    <b-form-group v-slot="{ ariaDescribedby }">
                                        <b-form-radio v-for="syncType in syncSettingTypes" :key="'work-order-sync-'+syncType.id"
                                                      v-model="syncSetting.workOrder.sync.type"
                                                      :aria-describedby="ariaDescribedby"
                                                      :name="'work-order-'+syncType.id"
                                                      :value="syncType.id"
                                                      :disabled="syncType.id === 'automatic' && !isWorkOrderModuleExistsOrEnabled"
                                                      stacked>
                                            {{ syncType.label }}
                                        </b-form-radio>
                                    </b-form-group>

                                    <!-- Work Order Sync Depend On -->
                                    <erp-sync-setting-automatic-sync v-if="syncSetting.workOrder.sync.type === 'automatic'"
                                                                     key="work-order-sync"
                                                                     type="workOrder"
                                                                     type-label="work order"
                                                                     :sync-depend-types="syncDependTypes"
                                                                     :time-interval-types="timeIntervalTypes"
                                                                     :time-interval-unit-types="timeIntervalUnitTypes"
                                                                     :time-interval-direction-types="timeIntervalDirectionTypes"
                                                                     :sync-settings="syncSetting.workOrder.sync"
                                                                     :is-work-order-push-allowed="isWorkOrderPushAllowed"
                                                                     :is-work-order-sync-allowed="isWorkOrderSyncAllowed"
                                                                     :connected-erp-integration="connectedErpIntegration"
                                                                     :connected-e-r-p-name="connectedERPName"
                                                                     v-on:syncSettingChanged="getChangedSyncSetting">
                                    </erp-sync-setting-automatic-sync>
                                </div>

                                <!-- JC Contract Tab -->
                                <div v-if="connectedErpIntegration === 'vista'" class="tab-pane text-black text-sm fade" id="pills-jc-contract" role="tabpanel" aria-labelledby="pills-jc-contract-tab">
                                    <!-- JC Contract Sync -->
                                    <div>
                                        How would you like your JC Contract to sync?
                                        <i
                                            class="fa fa-info-circle text-grey-dark"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="Settings are available based on the mapping directions within individual modules.">
                                        </i>
                                    </div>
                                    <b-form-group v-slot="{ ariaDescribedby }">
                                        <b-form-radio v-for="syncType in syncSettingTypes" :key="'jc-contract-sync-'+syncType.id"
                                                      v-model="syncSetting.jcContract.sync.type"
                                                      :aria-describedby="ariaDescribedby"
                                                      :name="'jc-contract-'+syncType.id"
                                                      :value="syncType.id"
                                                      :disabled="syncType.id === 'automatic' && !isJCContractModuleExistsOrEnabled"
                                                      stacked>
                                            {{ syncType.label }}
                                        </b-form-radio>
                                    </b-form-group>

                                    <!-- JC Contract Sync Depend On -->
                                    <erp-sync-setting-automatic-sync v-if="syncSetting.jcContract.sync.type === 'automatic'"
                                                                     key="jc-contract-sync"
                                                                     type="jcContract"
                                                                     type-label="JC Contract"
                                                                     :sync-depend-types="syncDependTypes"
                                                                     :time-interval-types="timeIntervalTypes"
                                                                     :time-interval-unit-types="timeIntervalUnitTypes"
                                                                     :time-interval-direction-types="timeIntervalDirectionTypes"
                                                                     :sync-settings="syncSetting.jcContract.sync"
                                                                     :is-j-c-contract-sync-allowed="isJCContractSyncAllowed"
                                                                     :connected-erp-integration="connectedErpIntegration"
                                                                     :connected-e-r-p-name="connectedERPName"
                                                                     v-on:syncSettingChanged="getChangedSyncSetting">
                                    </erp-sync-setting-automatic-sync>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer bg-white  p-2 px-3">
                        <button type="button" class="btn btn-link font-medium" data-dismiss="modal">Cancel</button>
                        <button @click="saveERPSyncSetting" type="button" class="btn btn-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import ErpSyncSettingAutomaticSync from "./erp-sync-setting-automatic-sync.vue";
import Swal from "sweetalert2";

const defaultSyncSettings = {
    project: {
        push: {
            type: 'manual',
            depends: 'sales-status',
            salesStatusId: null
        },
        sync: {
            type: 'manual',
            depends: null,
            timeInterval: {
                type: null,
                timeNumber: null,
                timeUnit: 'hour',
                direction: null
            }
        }
    },
    company: {
        sync: {
            type: 'manual',
            depends: null,
            timeInterval: {
                type: null,
                timeNumber: null,
                timeUnit: 'hour',
                direction: null
            }
        }
    },
    residentialContact: {
        sync: {
            type: 'manual',
            depends: null,
            timeInterval: {
                type: null,
                timeNumber: null,
                timeUnit: 'hour',
                direction: null
            }
        }
    },
    changeOrder: {
        sync: {
            type: 'manual',
            depends: null,
            timeInterval: {
                type: null,
                timeNumber: null,
                timeUnit: 'hour',
                direction: null
            }
        }
    },
    workOrder: {
        push: {
            type: 'manual',
            depends: 'sales-status',
            salesStatusId: null
        },
        sync: {
            type: 'manual',
            depends: null,
            timeInterval: {
                type: null,
                timeNumber: null,
                timeUnit: 'hour',
                direction: null
            }
        }
    },
    jcContract: {
        sync: {
            type: 'manual',
            depends: null,
            timeInterval: {
                type: null,
                timeNumber: null,
                timeUnit: 'hour',
                direction: null
            }
        }
    }
};
export default {
    name: 'erp-sync-setting',
    components: {ErpSyncSettingAutomaticSync},
    props: ['erpIntegrationId', 'connectedErpIntegration', 'moduleMappings', 'vistaConnection'],
    data() {
        return {
            syncSettingTypes: [
                {id: 'manual', label: 'Manually'},
                {id: 'automatic', label: 'Automatically'}
            ],
            projectPushDependTypes: [
                {id: 'sales-status', label: 'Project Status'}
            ],
            syncDependTypes: [
                {id: 'time-interval', label: 'Set Time Interval'},
                {id: 'update', label: 'Updates'}
            ],
            timeIntervalTypes: [
                {id: null, label: 'Select Time Interval'},
                {id: 'daily', label: 'Daily'},
                {id: 'weekly', label: 'Weekly'},
                {id: 'custom', label: 'Custom'}
            ],
            timeIntervalUnitTypes: [
                {id: 'hour', label: 'hour(s)'},
                {id: 'day', label: 'day(s)'},
                {id: 'week', label: 'week(s)'},
                {id: 'month', label: 'month(s)'}
            ],
            timeIntervalDirectionTypes: [
                {id: null, label: 'Select Direction'},
                {id: 'pull-from-followup', label: 'Push from Followup'},
                {id: 'pull-from-erp', label: 'Pull from ERP'},
            ],
            salesStatuses: [],
            syncSetting: _.cloneDeep(defaultSyncSettings),
            loader: false
        }
    },
    mounted() {
        this.getSalesStatuses();
        this.manageToolTip();
    },
    computed: {
        isProjectPushAllowed() {
            const response = this.isProjectSyncSettingAllowed();
            return response !== undefined && response.direction !== 'one-way-followup';
        },
        isProjectSyncAllowed() {
            const response = this.isProjectSyncSettingAllowed();
            return response !== undefined && response.direction !== 'one-way-third-party';
        },
        isCompanyPushAllowed() {
            const response = this.isSyncSettingAllowedFor('Company');
            return response !== undefined && response.direction !== 'one-way-followup';
        },
        isCompanySyncAllowed() {
            const response = this.isSyncSettingAllowedFor('Company');
            return response !== undefined && response.direction !== 'one-way-third-party';
        },
        isResidentialContactPushAllowed() {
            const response = this.isSyncSettingAllowedFor('Residential-contact');
            return response !== undefined && response.direction !== 'one-way-followup';
        },
        isResidentialContactSyncAllowed() {
            const response = this.isSyncSettingAllowedFor('Residential-contact');
            return response !== undefined && response.direction !== 'one-way-third-party';
        },
        isChangeOrderPushAllowed() {
            const response = this.isSyncSettingAllowedFor('Project-change-order');
            return response !== undefined && response.direction !== 'one-way-followup';
        },
        isChangeOrderSyncAllowed() {
            const response = this.isSyncSettingAllowedFor('Project-change-order');
            return response !== undefined && response.direction !== 'one-way-third-party';
        },
        isWorkOrderPushAllowed() {
            const response = this.isWorkOrderSyncSettingAllowed();
            return response !== undefined && response.direction !== 'one-way-followup';
        },
        isWorkOrderSyncAllowed() {
            const response = this.isWorkOrderSyncSettingAllowed();
            return response !== undefined && response.direction !== 'one-way-third-party';
        },
        isJCContractSyncAllowed() {
            const response = this.isJCContractSyncSettingAllowed();
            return response !== undefined && response.direction !== 'one-way-third-party';
        },
        connectedERPName() {
            if(this.connectedErpIntegration === 'sage-300-cre') {
                return 'Sage 300 CRE';
            }
            if(this.connectedErpIntegration === 'foundationNew') {
                return 'Foundation';
            }
            return this.connectedErpIntegration
                .split('-')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        },
        isProjectModuleExistsOrEnabled() {
            const response = this.isProjectSyncSettingAllowed();
            return response !== undefined && response.status == true;
        },
        isCompanyModuleExistsOrEnabled() {
            const response = this.isSyncSettingAllowedFor('Company');
            return response !== undefined && response.status == true;
        },
        isResidentialContactModuleExistsOrEnabled() {
            const response = this.isSyncSettingAllowedFor('Residential-contact');
            return response !== undefined && response.status == true;
        },
        isChangeOrderModuleExistsOrEnabled() {
            const response = this.isSyncSettingAllowedFor('Project-change-order');
            return response !== undefined && response.status == true;
        },
        isWorkOrderModuleExistsOrEnabled() {
            const response = this.isWorkOrderSyncSettingAllowed();
            return response !== undefined && response.status == true;
        },
        isJCContractModuleExistsOrEnabled() {
            const response = this.isJCContractSyncSettingAllowed();
            return response !== undefined && response.status == true;
        },
    },
    methods: {
        openSyncSettingModal() {
            this.getERPSyncSetting();
            $('#erpSyncSettingModal').modal('show');
        },
        closeSyncSettingModal() {
            $('#erpSyncSettingModal').modal('hide');
        },
        getSalesStatuses() {
            axios.get(route('api.settings.codes.sales-status.index')).then((response) => {
                this.salesStatuses = response.data;
            });
        },
        getChangedSyncSetting(data, type) {
            this.syncSetting[type].sync.depends = data.depends;
            this.syncSetting[type].sync.timeInterval = data.timeInterval;
        },
        getERPSyncSetting() {
            let self = this;
            self.loader = false;

            axios.post(route('api.erp.sync-setting.index'), {connectionId: self.vistaConnection? self.vistaConnection.id : null}).then((response) => {
                if(response.data.syncSetting) {
                    self.syncSetting = response.data.syncSetting;
                }
                self.loader = false;
            }).catch((error) => {
                self.loader = false;
            });
        },
        saveERPSyncSetting() {
            let self = this;

            if(!self.validateSyncSetting()) {
                return false;
            }

            let payload = {erpIntegrationId: self.erpIntegrationId, syncSetting: self.syncSetting, connectionId: self.vistaConnection ? self.vistaConnection.id : null};

            axios.post(route('api.erp.sync-setting.store'), payload).then((response) => {
                self.getToast().fire({
                    type: "success",
                    title: 'ERP sync settings saved successfully!'
                });
                self.closeSyncSettingModal();
            }).catch((error) => {
                console.error("Error: " + error);
            });
        },
        showToast(type, title){
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            Toast.fire({
                type: type,
                title: title
            });
        },
        formatSyncObjectLabels(label) {
            return label
                .replace(/([a-z])([A-Z])/g, '$1 $2')
                .toLowerCase();
        },
        validateSyncSetting() {
            return !Object.keys(this.syncSetting).some(key => {
                let obj = this.syncSetting[key];

                if(key === 'project') {
                    if(obj.push.type === 'automatic' && (obj.push.depends === null || obj.push.depends === undefined)) {
                        this.showToast('error', 'Please select depend type in '+ this.formatSyncObjectLabels(key) +' push section!');
                        return true;
                    }
                    if(obj.push.type === 'automatic' && obj.push.depends === 'sales-status' && (obj.push.salesStatusId === null || obj.push.salesStatusId === undefined)) {
                        this.showToast('error', 'Please select a sales status in '+ this.formatSyncObjectLabels(key) +' push section!');
                        return true;
                    }
                }

                if(obj.sync.type === 'automatic') {
                    if(obj.sync.depends === null || obj.sync.depends === undefined) {
                        this.showToast('error', 'Please select depend type in '+ this.formatSyncObjectLabels(key) +' sync section!');
                        return true;
                    }
                    if(obj.sync.depends === 'time-interval') {
                        if(obj.sync.timeInterval.type === null || obj.sync.timeInterval.type === undefined) {
                            this.showToast('error', 'Please select time interval in '+ this.formatSyncObjectLabels(key) +' sync section!');
                            return true;
                        }
                        if(obj.sync.timeInterval.type === 'custom' && (obj.sync.timeInterval.timeNumber === null || obj.sync.timeInterval.timeNumber === undefined)) {
                            this.showToast('error', 'Please enter time interval value in '+ this.formatSyncObjectLabels(key) +' sync section!');
                            return true;
                        }
                        if(obj.sync.timeInterval.type === 'custom' && obj.sync.timeInterval.timeNumber <= 0) {
                            this.showToast('error', 'Please enter time interval value greater than 0 in '+ this.formatSyncObjectLabels(key) +' sync section!');
                            return true;
                        }
                        if(obj.sync.timeInterval.direction === null || obj.sync.timeInterval.direction === undefined) {
                            this.showToast('error', 'Please select time interval direction in '+ this.formatSyncObjectLabels(key) +' sync section!');
                            return true;
                        }
                    }
                }

                return false;
            });
        },
        isProjectSyncSettingAllowed() {
            const thirdPartyJobModules = ['JCJM', 'JC_JOB_MASTER_MC', 'jobs', 'actrec', 'MASTER_JCM_RECORD_1'];
            return _.find(this.moduleMappings, function(module) {
                return module.followUp === 'Project' && thirdPartyJobModules.includes(module.thirdParty);
            });
        },
        isSyncSettingAllowedFor(object) {
            return _.find(this.moduleMappings, function(module) {
                return module.followUp === object;
            });
        },
        isWorkOrderSyncSettingAllowed() {
            return _.find(this.moduleMappings, function(module) {
                return module.followUp === 'Project' && module.thirdParty === 'vSMWorkOrder';
            });
        },
        isJCContractSyncSettingAllowed() {
            return _.find(this.moduleMappings, function(module) {
                return module.thirdParty === 'bJCCM';
            });
        },
        manageToolTip() {
            const tooltipSelector = $('[data-toggle="tooltip"]');
            tooltipSelector.tooltip({
                trigger: 'hover'
            });
        }
    },
}
</script>
<style scoped>
    #erpSyncSettingModal .nav-link:focus {
        outline: none;
    }
    #erpSyncSettingModal .nav-pills .active{
        outline: none;
        border-bottom: 2px solid #01b1af;
        color: #01b1af !important;
    }
    #erpSyncSettingModal .text-black {
        color: #22292f !important;
    }
    #erpSyncSettingModal .custom-radio {
        display: block !important;
    }
    .depend-on-section {
        border-radius: 4px;
    }
    .loader-overlay {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(255, 255, 255, 0.7);
        width: 100%;
        height: 100%;
    }
</style>
<style>
    #erpSyncSettingModal .custom-control-input:checked ~ .custom-control-label::before,
    #erpSyncSettingModal .custom-control-input:checked ~ .custom-control-label::after {
        background-color: #01b1af !important;
        border-color: #01b1af !important;
        border-radius: 100%;
    }
</style>
